<div class="navbar-top-navigation-panel">
  @for (client of _clientList; track client.clientId) {
    @if (!client.hidden) {
      <div class="navbar-top-navigation-panel-client">
        <!-- Client data -->
        <span>
          {{ client.clientName }}
          <i class="fas fa-user-tie"></i>
        </span>
        <div class="navbar-top-navigation-panel-separator" [style.height.px]="client.height"></div>

        <!-- Entity panel -->
        <div class="navbar-top-navigation-panel-entity-container">
          <!-- Entities -->
          @for (entity of client.entityList; track entity.id) {
            @if (!entity.hidden) {
              <div
                class="navbar-top-navigation-panel-entity"
                [style.height.px]="entity.height"
                [style.width.px]="entity.width"
              >
                <!-- Entity data -->
                <span>
                  <i class="fas fa-sitemap"></i>
                  <div
                    (click)="updateNavigation({ client: client, entity: entity, agrupation: null })"
                  >
                    <span [appHighlightText]="filterText" [innerHTML]="entity.entity"></span>
                    @if (entity.alias) {
                      <span [appHighlightText]="filterText" [innerHTML]="entity.alias"></span>
                    }
                  </div>
                </span>
                <!-- Agrupation panel -->
                <article
                  class="navbar-top-navigation-panel-agrupation-container"
                  [style.column-count]="entity.columns"
                >
                  <div class="navbar-top-navigation-panel-separator"></div>

                  <!-- Agrupations -->
                  @for (agrupation of entity.agrupations; track agrupation.id) {
                    @if (!agrupation.hidden) {
                      <!-- Agrupation data -->
                      <span>
                        <i class="fas fa-map"></i>
                        <div
                          (click)="
                            updateNavigation({
                              client: client,
                              entity: entity,
                              agrupation: agrupation
                            })
                          "
                        >
                          <span
                            [appHighlightText]="filterText"
                            [innerHTML]="agrupation.name"
                          ></span>
                          @if (agrupation.alias) {
                            <span
                              [appHighlightText]="filterText"
                              [innerHTML]="agrupation.alias"
                            ></span>
                          }
                        </div>
                      </span>
                    }
                  }
                </article>
              </div>
            }
          }
        </div>
      </div>
    }
  }
</div>
